import { render } from "./acceptedOrders.vue?vue&type=template&id=71a2f1e3&scoped=true"
import script from "./acceptedOrders.vue?vue&type=script&lang=js"
export * from "./acceptedOrders.vue?vue&type=script&lang=js"

import "./acceptedOrders.vue?vue&type=style&index=0&id=71a2f1e3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71a2f1e3"

export default script